import { Button, Flex, Form, Grid, Input, Modal } from "antd";
import React, { useState } from "react";
import { useCreateItemMutation } from "../actions/app/items";

const { TextArea } = Input;
const { useBreakpoint } = Grid;

function FeatureRequestBox({ trigger }) {
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const screens = useBreakpoint();
    const isMobile = !screens.sm;

    const mutationCreate = useCreateItemMutation(() => {
        setOpen(false);
        form.resetFields();
        Modal.success({
            title: "Feature request created",
            content:
                "Thankyou for your feedback. We'll keep you informed regarding this.",
        });
    });

    return (
        <>
            <div onClick={() => setOpen(!open)}>{trigger}</div>
            <Modal
                title="New feature request"
                open={open}
                centered={isMobile}
                width={isMobile ? "calc(100vw - 32px)" : 520}
                styles={{
                    body: { padding: isMobile ? "0" : "24px" },
                }}
                footer={
                    <Flex gap={8}>
                        <Button
                            block={isMobile}
                            size={isMobile ? "large" : "middle"}
                            style={isMobile ? { flex: 1 } : {}}
                            onClick={() => setOpen(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            block={isMobile}
                            type="primary"
                            size={isMobile ? "large" : "middle"}
                            style={isMobile ? { flex: 1 } : {}}
                            loading={mutationCreate.isLoading}
                            onClick={() => form.submit()}
                        >
                            Submit
                        </Button>
                    </Flex>
                }
                onCancel={() => setOpen(false)}
            >
                <Form
                    layout="vertical"
                    form={form}
                    onFinish={(values) => {
                        mutationCreate.mutate({
                            collection: "qdb_feature_request",
                            data: { ...values },
                        });
                    }}
                >
                    <Form.Item label="Title" name="title">
                        <Input
                            placeholder="Title"
                            size={isMobile ? "large" : "middle"}
                        />
                    </Form.Item>
                    <Form.Item label="Description" name="description">
                        <TextArea
                            placeholder="Description"
                            rows={isMobile ? 6 : 10}
                            size={isMobile ? "large" : "middle"}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
}

export default FeatureRequestBox;
